import { Card, withStyles } from '@material-ui/core';

export const CardWithHoverColorChange = createCardWithBackgroundHoverColorChange('#FFFFFF');

export function createCardWithBackgroundHoverColorChange(backgroundColor: string): any {
  return withStyles({
    root: {
      background: 'none',
      '&:hover': {
        background: backgroundColor + '33',
      },
    },
  })(Card);
}
